@if (open()) {
  <div class="comment-modal" role="dialog" aria-modal="true" aria-label="Reject and escalate">
    <button type="button" class="comment-modal__backdrop" aria-label="Close" (click)="closed.emit()"></button>
    <div class="comment-modal__panel">
      <header class="comment-modal__header">
        <h3 class="comment-modal__title">Reject &amp; Escalate</h3>
        <button type="button" class="comment-modal__close" aria-label="Close" (click)="closed.emit()">
          <i class="pi pi-times"></i>
        </button>
      </header>
      <textarea
        class="comment-modal__textarea"
        rows="4"
        placeholder="Add a comment explaining why this is being rejected…"
        [value]="draft()"
        (input)="onInput($event)"></textarea>
      <footer class="comment-modal__actions">
        <button
          type="button"
          class="iopoc-button small secondary"
          (click)="closed.emit()">
          Cancel
        </button>
        <button
          type="button"
          class="iopoc-button small danger"
          [disabled]="!draft().trim()"
          (click)="confirmRequested.emit()">
          Reject &amp; Escalate
        </button>
      </footer>
    </div>
  </div>
}
